import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {SettingService} from "../../store/setting/setting.service";

/**
 * Generated class for the SettingAdvancedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-advanced',
  templateUrl: 'setting-advanced.html',
})
export class SettingAdvancedPage {

  public settings: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private settingService: SettingService) {
    this.settings = this.navParams.get('settings');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingAdvancedPage');
  }

  public save(signature): void {

    if (this.settings.signature !== signature) {
      this.settings.signature = signature;
      this.settingService.set(this.settings, false);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/setting-advanced/setting-advanced.ts